import { render } from "./Q13EComponent.vue?vue&type=template&id=49f1eff6&scoped=true"
import script from "./Q13EComponent.vue?vue&type=script&lang=js"
export * from "./Q13EComponent.vue?vue&type=script&lang=js"

import "./Q13EComponent.vue?vue&type=style&index=0&id=49f1eff6&scoped=true&lang=css"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f1eff6"]])

export default __exports__